import { useMemo } from 'react';

import { CustomerDetailNames } from '~/shared/constants/customerDetailNames';
import useGender from '~/shared/utils/useGender';
import {
  useCustomerDetail,
  useMembership,
} from '~/techstyle-shared/react-accounts';
import { useDomain } from '~/techstyle-shared/redux-core';

import getHelpPageUrl from './getHelpPageUrl';

export default function useHelpPageUrl() {
  const domain = useDomain();
  const gender = useGender();
  const membership = useMembership();
  const membershipPriceTestDetailRecord = useCustomerDetail(
    CustomerDetailNames.M13_PERKS_2025
  );

  return useMemo(() => {
    return getHelpPageUrl({
      domain,
      gender,
      membership,
      membershipPriceTestDetailRecord,
    });
  }, [domain, gender, membership, membershipPriceTestDetailRecord]);
}
